import { Injectable } from "@angular/core";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { BaseLookupService } from "../../impl/BaseLookupService";
import { CubiqWorker } from "../../../worker/CubiqWorker";
import { IBlotterFilterLookupService } from "../IBlotterFilterLookupService";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

export const BlotterFilterNameSystemExcludeList = new Set([
  "BENCHMARK_TYPE_TRADE_FILTER",
  "LIMIT_TYPE_TRADE_FILTER",
  "ALGO_TYPE_TRADE_FILTER",
]);

@Injectable()
export class BlotterFilterLookupService
  extends BaseLookupService<string, CubiqTS.BlotterFilterImpl>
  implements IBlotterFilterLookupService
{
  constructor() {
    super(CubiqTS.BlotterFilterImpl);
  }

  getItem(key: string): CubiqTS.BlotterFilterImpl {
    return key ? this.myItemMap.get(key) : null;
  }

  getItemKey(item: CubiqTS.BlotterFilterImpl): string {
    return item.filterId.toString();
  }

  mapItem(item: CubiqTS.BlotterFilterImpl): void {
    if (BlotterFilterNameSystemExcludeList.has(item.filterName)) {
      logger.out.info(
        `${this.constructor.name}.mapItem ignoring ${item.filterName} as it is on the System Exclude List`,
      );
      return;
    }

    if (this.myItemMap.has(item.filterId.toString())) {
      let oldItem = this.getItem(item.filterId.toString());
      this.deleteItem(oldItem);
    }

    this.myItemMap.set(item.filterId.toString(), item);
  }

  deleteItem(item: CubiqTS.BlotterFilterImpl): void {
    this.myItemMap.delete(item.filterId.toString());
  }

  getMyBlotterFilters(currentUserId: string): Array<CubiqTS.BlotterFilterImpl> {
    let BlotterFilters: Array<CubiqTS.BlotterFilterImpl> = new Array<CubiqTS.BlotterFilterImpl>();
    return this.getAll().filter(
      (blotter: CubiqTS.BlotterFilterImpl) => blotter.entryUserId.toString() == currentUserId,
    );
  }

  getMyBlotterSystemFilters(): Array<CubiqTS.BlotterFilterImpl> {
    let BlotterFilters: Array<CubiqTS.BlotterFilterImpl> = new Array<CubiqTS.BlotterFilterImpl>();
    return this.getAll().filter(
      (blotter: CubiqTS.BlotterFilterImpl) => blotter.isSystemFilter === true,
    );
  }
}
